// theme.ts
import { extendTheme, ThemeConfig } from "@chakra-ui/react";

// Helpful constants if you want to reference raw values directly
export const zs = {
  dark: {
    background: "#0B0B0F",
    card: "#1A1C1F",
    cardMuted: "#14161B",
    border: "#2E2F33",
    cardLighter: "#3A4553",
    cardLightest: "#4A5463",
    goldFrom: "#FBD282",
    goldTo: "#B59143",
  },
  light: {
    background: "#F8FAFC",
    card: "#FFFFFF",
    cardMuted: "#F2F4F7",
    border: "#E5E7EB",
    textMuted: "#6B7280",
  },
};

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  semanticTokens: {
    colors: {
      "zs.background": { default: zs.dark.background, _light: zs.light.background },
      "zs.card": { default: zs.dark.card, _light: zs.light.card },
      "zs.cardMuted": { default: zs.dark.cardMuted, _light: zs.light.cardMuted },
      // Sidebar uses a slightly different dark hue to separate from page background
      "zs.sidebar": { default: "#14161B", _light: zs.light.cardMuted },
      "zs.border": { default: zs.dark.border, _light: zs.light.border },
      "zs.text": { default: "#FFFFFF", _light: "#111827" },
      "zs.muted": { default: zs.dark.cardLightest, _light: zs.light.textMuted },
      "zs.accent": { default: zs.dark.goldTo, _light: zs.dark.goldTo },
      "zs.accentSoft": { default: zs.dark.goldFrom, _light: zs.dark.goldFrom },
    },
  },
  styles: {
    global: {
      body: {
        bg: "zs.background",
        color: "zs.text",
        fontFamily: "Inter, sans-serif",
      },
    },
  },
  layerStyles: {
    card: {
      bg: "zs.card",
      borderWidth: "1px",
      borderColor: "zs.border",
      borderRadius: "xl",
    },
    cardMuted: {
      bg: "zs.cardMuted",
      borderWidth: "1px",
      borderColor: "zs.border",
      borderRadius: "xl",
    },
  },
  textStyles: {
    goldGradient: {
      bgGradient: `linear(to-r, ${zs.dark.goldFrom}, ${zs.dark.goldTo})`,
      bgClip: "text",
      fontWeight: 800,
    },
  },
  components: {
    Button: {
      variants: {
        gold: {
          bgGradient: `linear(to-r, ${zs.dark.goldFrom}, ${zs.dark.goldTo})`,
          color: "white",
          fontWeight: 700,
          _hover: {
            bgGradient: `linear(to-r, #E8C16C, #A7843D)`,
            boxShadow: `0 4px 12px rgba(181, 145, 67, 0.35)`,
          },
          _active: { transform: "translateY(0)" },
        },
      },
    },
  },
});

export default theme;
